import Model from '@/models/Model.js';

export default class ConfirmNavigationWindow extends Model {
    static entity = 'confirm_navigation_window';

    static state() {
        return {
            // Edverum Confirmation Window
            active: false,
        };
    }

    // chrome window
    static activate() {
        window.addEventListener('beforeunload', this.confirmNavigation);
    }

    // chrome window
    static disable() {
        window.removeEventListener('beforeunload', this.confirmNavigation);
    }

    // chrome window
    static confirmNavigation(event) {
        event.preventDefault();
        event.returnValue = '';
    }
}
